export const ADD_MID = 'ADD_MID';
export const REPORT_VALIDATION = 'REPORT_VALIDATION';
export const TRANSACTION_VALIDATION = 'TRANSACTION_REPORT_VALIDATION';
export const LOCATION_VALIDATION = 'TRANSACTION_REPORT_VALIDATION';
export const EQUIPMENT_VALIDATION = 'TRANSACTION_REPORT_VALIDATION';
export const STATEMENT_VALIDATION = 'TRANSACTION_REPORT_VALIDATION';
export const REPORT_BUILDER_VALIDATION = 'REPORT_BUILDER_VALIDATION';
export const SELF_REGISTERATION_VALIDATION = 'SELF_REGISTERATION_VALIDATION';
export const FILE_DOWNLOAD_FAILED = 'FILE_DOWNLOAD_FAILED';
export const INCORRECT_MERCHANT_NUMBER = 'INCORRECT_MERCHANT_NUMBER';
export const INCORRECT_DDA_TAXID = 'INCORRECT_DDA_TAXID';
export const INCORRECT_ACCOUNT_ADMIN_MID = 'INCORRECT_ACCOUNT_ADMIN_MID';
export const REPORT_SUPPORT_ACCESS = 'REPORT_SUPPORT_ACCESS';
export const SETTINGS = 'SETTINGS';
